const gtag = function () {
	dataLayer.push(arguments);
}

module.exports = gtag;
